import config from '@/config'

export default {
	id: 'SIMPLE_UPGRADE_9M_79_2',
	providers: {
		stripe: config('stripe_cheap_and_short_upgrade_9_month'),
		braintree: 'pro_short_cheap_upgrade',
		paltaMap: {
			USD: 'simple_premium_9m_79_2_usd',
			EUR: 'simple_premium_9m_79_2_eur',
			GBP: 'simple_premium_9m_79_2_gbp',
			AUD: 'simple_premium_9m_119_aud',
			CAD: 'simple_premium_9m_119_2_cad',
			DKK: 'simple_premium_9m_591_2_dkk',
			SEK: 'simple_premium_9m_943_2_sek',
			NOK: 'simple_premium_9m_943_2_nok',
			BRL: 'simple_premium_9m_239_20_brl',
			MXN: 'simple_premium_9m_1327_2_mxn',
			TRY: 'simple_premium_9m_2699_try',
			ARS: 'simple_premium_9m_105570_ars',
			COP: 'simple_premium_9m_321350_cop',
			CLP: 'simple_premium_9m_77120_clp',
		},
		primer: 'prd_ZX9EceijFRkb',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 9,
		intro_period_type: 'month',
		next_period_value: 9,
		next_period_type: 'month',
	},
	trial: null,
	subscription: {
		interval: 'month',
		intervalCount: 9,
		priceMap: {
			USD: 79.2,
			EUR: 79.2,
			GBP: 79.2,
			AUD: 119.2,
			CAD: 119.2,
			DKK: 591.2,
			SEK: 943.2,
			NOK: 943.2,
			BRL: 239.2,
			MXN: 1327.2,
			TRY: 2699,
			ARS: 105570,
			COP: 321350,
			CLP: 77120,
		},
	},
	options: ($t) => ({
		barChartTooltip: $t('activity_upgrade.9mo.bar_chart_tooltip'),
		barChartLeftLabel: $t('activity_upgrade.9mo.bar_chart_left_label'),
		barChartRightLabel: $t('activity_upgrade.9mo.bar_chart_right_label'),
	}),
}
